exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-47b74ec2] {\n  margin-top: 30px;\n}\n.information p[data-v-47b74ec2] {\n  margin: 5px;\n}", ""]);

// exports
